module.exports = __webpack_public_path__ + "static/media/MK.946a10e6.png";